import { cn } from '@seen/ui'
import { cva, type VariantProps } from 'class-variance-authority'
import type { JSX, ReactNode } from 'react'
import { IconUserPlaceholder } from '#src/components/icons/IconUserPlaceholder.tsx'

interface UserPlaceholderNameplateProps extends VariantProps<typeof variants> {
  className?: string
  children: ReactNode
}

export function UserPlaceholderNameplate({
  children,
  size,
  className,
}: UserPlaceholderNameplateProps): JSX.Element {
  return (
    <div className={cn(variants({ size, className }))}>
      <IconUserPlaceholder className={cn(size === 'xs' && 'size-3 p-0')} />
      <p>{children}</p>
    </div>
  )
}

const variants = cva('flex items-center', {
  variants: {
    size: {
      default: 'gap-2',
      xs: 'gap-1',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})
